// Auth actions
export const AUTH_SAVE = 'AUTH_SAVE';
export const AUTH_CLEAR = 'AUTH_CLEAR';


// Common actions
export const COMMON_ALERT = 'COMMON_ALERT';
export const COMMON_CLOSE_ALERT = 'COMMON_CLOSE_ALERT';
export const COMMON_MODAL_RESIZE = 'COMMON_MODAL_RESIZE';
export const COMMON_OPEN_CONTACT = 'COMMON_OPEN_CONTACT';
export const COMMON_CLOSE_CONTACT = 'COMMON_CLOSE_CONTACT';
export const COMMON_NOTIFY = 'COMMON_NOTIFY';
export const COMMON_CLOSE_NOTIFY = 'COMMON_CLOSE_NOTIFY';
export const COMMON_OPEN_LOGIN = 'COMMON_OPEN_LOGIN';
export const COMMON_CLOSE_LOGIN = 'COMMON_CLOSE_LOGIN';
export const COMMON_NAV_CHANGE = 'COMMON_NAV_CHANGE';

// Header actions
export const HEADER_TOGGLE = 'HEADER_TOGGLE';
export const HEADER_SUBMENU = 'HEADER_SUBMENU';

// Login actions
// None

// Product actions
export const PRODUCT_SAVE_DIAMOND_QUERY = 'PRODUCT_SAVE_DIAMOND_QUERY';
export const PRODUCT_ADD_DIAMONDS = 'PRODUCT_ADD_DIAMONDS';
export const PRODUCT_SAVE_DIAMONDS = 'PRODUCT_SAVE_DIAMONDS';
export const PRODUCT_APPEND_DIAMONDS = 'PRODUCT_APPEND_DIAMONDS';
export const PRODUCT_SAVE_SETTING_QUERY = 'PRODUCT_SAVE_SETTING_QUERY';
export const PRODUCT_SAVE_SETTINGS = 'PRODUCT_SAVE_SETTINGS';
export const PRODUCT_SELECT_SETTING = 'PRODUCT_SELECT_SETTING';
export const PRODUCT_SELECT_DIAMOND = 'PRODUCT_SELECT_DIAMOND';
export const PRODUCT_COMPARE_SETTING = 'PRODUCT_COMPARE_SETTING';
export const PRODUCT_COMPARE_DIAMOND = 'PRODUCT_COMPARE_DIAMOND';
export const PRODUCT_COMPARE_BAND = 'PRODUCT_COMPARE_BAND';
export const PRODUCT_COMPARE_FASHION = 'PRODUCT_COMPARE_FASHION';
export const PRODUCT_CLEAR_QUERY = 'PRODUCT_CLEAR_QUERY';
export const PRODUCT_SET_PAGE = 'PRODUCT_SET_PAGE';
export const PRODUCT_ATTR_SIZE = 'PRODUCT_ATTR_SIZE';
export const PRODUCT_ATTR_METAL = 'PRODUCT_ATTR_METAL';
export const PRODUCT_RESET_DIAMOND_QUERY = 'PRODUCT_RESET_DIAMOND_QUERY';
export const PRODUCT_RESET_PRODUCT_QUERY = 'PRODUCT_RESET_PRODUCT_QUERY';
export const PRODUCT_FLOATING_HEADER_TOGGLE = 'PRODUCT_FLOATING_HEADER_TOGGLE';


// Results actions
export const RESULTS_SET_SOURCE = 'RESULTS_SET_SOURCE';
export const RESULTS_SET_SOURCE_LOCATION = 'RESULTS_SET_SOURCE_LOCATION';
export const RESULTS_SET_SORT = 'RESULTS_SET_SORT';

// User (global) actions
export const USER_LOGOUT = 'USER_LOGOUT';

// User (non-Global) actions
export const USER_CORE_SET = 'USER_CORE_SET';
export const USER_PROFILE_SET = 'USER_PROFILE_SET';
export const USER_WISHLISTS_SET = 'USER_WISHLISTS_SET';
export const USER_ORDERS_SET = 'USER_ORDERS_SET';
export const USER_EXTERNAL_ORDERS_SET = 'USER_EXTERNAL_ORDERS_SET';


// WEBPACK FOOTER //
// ./src/constants/actions.jsx